import { setupMPApps } from '../setupMPApps'
;(async () => {
  await setupMPApps()
  require.ensure(['./bootstrap'], require => require('./bootstrap'))
})()
